<template>
  <div class="d-flex qtm-body-small text-mid-light-grey">
    <template v-for="(step, i) in steps" :key="step.value">
      <div class="d-flex flex-column align-center position-relative pb-4">
        <v-icon v-if="i < index" color="secondary" icon="mdi-check-circle" size="24px" />
        <div v-else class="step" :class="{ 'text-secondary': i === index }">
          <div v-if="i === index" class="active-step" />
        </div>
        <div class="label text-mid-dark-grey" v-text="step.label" />
      </div>
      <div v-if="i < steps.length - 1" class="separator" />
    </template>
  </div>
</template>

<script setup lang="ts">
export interface Step {
  value: string
  label: string
}

export interface Props {
  modelValue?: string
  steps: Step[]
}

const props = defineProps<Props>()

const index = computed(() => props.steps.findIndex(step => step.value === props.modelValue))
</script>

<style lang="scss" scoped>
$size: 20px;

.step {
  display: flex;
  align-items: center;
  justify-content: center;
  height: $size;
  width: $size;
  background: white;
  border: 1px solid currentColor;
  border-radius: 50%;
  margin-top: 2px;
}

.separator {
  margin-top: calc($size / 2) + 2px;
  margin-left: -2px;
  margin-right: -2px;
  border-top: 1px solid currentColor;
  width: 175px;
}

.label {
  top: $size + 6px;
  position: absolute;
  white-space: nowrap;
}

$active-margin: 4px;
$active-size: $size - 2 * $active-margin;

.active-step {
  background: currentColor;
  height: $active-size;
  width: $active-size;
  border-radius: 50%;
}
</style>
